<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <QuestionBase class="lgrm-openended">
    <template v-slot:question>
      <slot name="question">{{ updatedQuestion }}</slot>
    </template>

    <template v-slot:question-options>
      <slot name="question-options">
        <textarea
          v-model="text"
          @input="$emit('change', text)"
          class="lgrm-openended-text-area"
        ></textarea>
      </slot>
    </template>
  </QuestionBase>
</template>

<script>
import QuestionBase from './QuestionBase'
export default {
  name: 'OpenendedQuestion',
  components: { QuestionBase },
  props: {
    question: {
      type: String,
      default: 'Overall how satisfied are you with {brand_name}'
    },
    brandName: String,
    color: { type: String, default: 'red' },
    value: String
  },
  data: function() {
    return {
      text: this.value,
      vertical: false
    }
  },
  computed: {
    updatedQuestion: function() {
      if (this.brandName)
        return this.question.replace('{brand_name}', this.brandName)
      return this.question
    }
  },
  methods: {},
  beforeDestroy() {}
}
</script>

<style lang="stylus" scoped>
.lgrm-openended
  .lgrm-openended-text-area
      display: inline-block
      text-align left
      font-size 16px
      min-width: 200px;
      max-width 500px
      width 450px
      height: 90px;
      background: #F3F3F3;
      border: 1px solid #B7B7B7;
      box-sizing: border-box;
      border-radius: 5px;
      outline none
      @media (max-width 400px) { 
        min-width: 150px;
        width 300px
      }
</style>
